import { render, staticRenderFns } from "./DirectDiscount.vue?vue&type=template&id=3596cf98&scoped=true&"
import script from "./DirectDiscount.vue?vue&type=script&lang=js&"
export * from "./DirectDiscount.vue?vue&type=script&lang=js&"
import style0 from "./DirectDiscount.vue?vue&type=style&index=0&id=3596cf98&scoped=true&lang=scss&"
import style1 from "./DirectDiscount.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596cf98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
